import { render, staticRenderFns } from "./CommonPost.vue?vue&type=template&id=6711b49a&scoped=true&"
import script from "./CommonPost.vue?vue&type=script&lang=js&"
export * from "./CommonPost.vue?vue&type=script&lang=js&"
import style0 from "./CommonPost.vue?vue&type=style&index=0&id=6711b49a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6711b49a",
  null
  
)

export default component.exports